export const socialShare = () => {
  const share = document.querySelector("#share");

  if (share) {
    const shareToggle = share.querySelectorAll(".share-toggle");
    if (shareToggle) {
      shareToggle.forEach((toggle) => {
        toggle.addEventListener("click", function (e) {
          e.preventDefault();
          share.classList.toggle("open");
        });
      });

      document.addEventListener("click", function (e) {
        if (!e.target.closest(".share")) {
          share.classList.remove("open");
        }
      });
    }
  }
};
